var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { LocalityType } from '@domain-group/fe-allhomes-library';
import { LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { LocalityLinkCard } from '@domain-group/fe-co-allhomes-shared-components';
var Image = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/agent-female-circle_86c456cc.svg";
import * as styles from './sidebox.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment OffMarketSidebox on Property {\n    address {\n      division {\n        slug\n      }\n    }\n  }\n"])));
var Sidebox = _ref => {
  var divisionName = _ref.divisionName,
    searchUri = _ref.searchUri,
    divisionSlug = _ref.divisionSlug;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  return ___EmotionJSX("div", {
    css: styles.sidebox
  }, ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.header
  }, ___EmotionJSX("div", {
    css: styles.headerText
  }, "Selling in ", divisionName, "?")), ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX("img", {
    css: styles.image,
    src: Image,
    alt: ""
  }), ___EmotionJSX("div", {
    css: styles.contentBottom
  }, ___EmotionJSX("div", {
    css: styles.contentText
  }, "Compare these top-performing sales agents in your area"), ___EmotionJSX(LinkButton, {
    href: getAbsoluteUrl(searchUri),
    css: styles.button,
    appearance: "accent",
    stretched: true,
    onClick: () => {
      sendEvent('find-an-agent');
    }
  }, "View sales agents")))), ___EmotionJSX(LocalityLinkCard, {
    title: divisionName,
    text: "View suburb profile",
    localityType: LocalityType.DIVISION.type,
    link: getAbsoluteUrl("/research/".concat(divisionSlug)),
    onClick: () => sendEvent('click-research-cta-sticky')
  }));
};
Sidebox.fragment = fragment;
Sidebox.propTypes = {
  divisionName: PropTypes.string.isRequired,
  searchUri: PropTypes.string.isRequired,
  divisionSlug: PropTypes.string.isRequired
};
export default Sidebox;